<script>
import 'bulma/css/bulma.css'
import linkPrevue from 'link-prevue'
import {getIdFromUrl} from 'vue-youtube'

export default {
  components: {
    linkPrevue
  },
  props: ['url'],
  data () {
    return {
      videoId: ''
    }
  },
  created () {
    this.videoId = getIdFromUrl(this.url)
    // console.log('videoId')
    // console.log(this.videoId)
  },
  computed: {
    player () {
      if (this.videoId) {
        return this.$refs.youtube.player
      }
    }
  },
  updated () {
    this.videoId = getIdFromUrl(this.url)
    // console.log('videoId')
    // console.log(this.videoId)
  },
  methods: {
    async playVideo () {
      await this.player.playVideo()
    },
    playing () {
      // console.log('we are watching!')
    },
    paused () {
      // console.log('paused')
    },
    ended () {
      // console.log('ended')
    }
  }
}
</script>
<style scoped>
.link {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  padding-top: 10px;
}
.card-title {
  margin-bottom: 0px !important;
}
.loader-container {
  width: 0px;
}
@media screen and (min-width:768px) {
  .card {
    width: 50%;
    border: 1px solid;
    border-radius: 4px;
    border-color: #A9A9A9;
    padding: 10px;
    box-shadow: 0 0 0 0px rgba(10,10,10,.1);
    background-color: #fcfcfc;
  }
  .card-img .card-img-top{
    width: auto;
    max-height: 200px !important;
    border-radius: 7px 7px 0 0;
  }
  .video {
    width: 60%;
  }
}
@media screen and (max-width:769px) {
  .card {
    width: auto;
    border: 1px solid;
    border-radius: 4px;
    border-color: #A9A9A9;
    padding: 10px;
    box-shadow: 0 0 0 0px rgba(10,10,10,.1);
    background-color: #fcfcfc;
  }
  .card-img .card-img-top{
    width: auto;
    max-height: 150px !important;
    border-radius: 7px 7px 0 0;
  }
  .video {
    width: auto;
  }
}

</style>
<template>
  <link-prevue :url="url" v-if="!videoId">
    <template slot-scope="props">
      <div class="link">
        <div class="card" v-if="props.img">
          <div class="card-block">
            <p class="card-title has-text-weight-bold is-size-7">{{props.title}}</p>
            <a v-bind:href="props.url"  class="card-text is-size-7" target="_blank">{{props.description}}</a>
          </div>
          <a class="card-img" v-bind:href="props.url"  target="_blank">
            <img class="card-img-top" :src="props.img" :alt="props.title">
          </a>
        </div>
      </div>
    </template>
    <template slot="loading">
      <div class="loader-container"></div>
      <!-- set your custom loading -->
    </template>
  </link-prevue>
  <div v-else class="video">
    <youtube
    class="youtube"
    ref="youtube"
    :video-id="videoId"
    @playing="playing()"
    @paused="paused()"
    @ended="ended()"
    fitParent=true
    resize=true
    />
    <!--button @click="playVideo()">play</button-->
  </div>
</template>



// WEBPACK FOOTER //
// src/components/LinkNodeCard.vue